import React from "react";
import Button from "react-bootstrap/Button";
import Image from "react-bootstrap/Image";
import config from "../../config";
import { RebagPlusLogo } from "../common/Icons";

const FirstLookPreviewOverlay = ({productHandle, firstLookProduct, plpMode}) => {
    if (!firstLookProduct || !plpMode) { return null; }

    return (
        <div className="first-look-preview__overlay">
            <div className="first-look-preview__body">
                <Button
                    className="first-look-preview__icon-container"
                    variant="clean"
                    href={`${config.host_rebag_shop}/products/${productHandle}`}
                >
                    <Image
                        className="first-look-preview__overlay-image"
                        alt="VIP Preview"
                        src={`${config.MEDIA_URL}/img/rewards/first-look-preview-bkgr-plus-5.jpg`}
                    />
                    <div className="first-look-preview__buttons-container">
                        <RebagPlusLogo
                            style={{ width: 100 }}
                            color="#FFFFFF"
                            label="Rebag+ Membership"
                        />
                        <div className="first-look-preview__text">
                            Only Rebag⁺ members can shop VIP Preview of New Arrivals. Join for $50/month, which becomes store credit, or set an alert to be notified if this item becomes available.
                        </div>
                        <div className="first-look-preview__cta">
                            See Item Details
                        </div>
                    </div>
                </Button>
            </div>
        </div>
    )
}

export default FirstLookPreviewOverlay;